import { class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FSharpRef, toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { create, toDateTime, minValue as minValue_1, fromDateTime } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { today, tryParse, minValue, parse } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { tryParse as tryParse_1, parse as parse_1 } from "../fable_modules/fable-library-js.4.24.0/Decimal.js";
import Decimal from "../fable_modules/fable-library-js.4.24.0/Decimal.js";
import { filter, ofNullable, value as value_2, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { join, interpolate, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { isEmpty, FSharpSet__Contains, FSharpSet__Remove, FSharpSet__Add } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { FSharpChoice$3, FSharpChoice$2 } from "../fable_modules/fable-library-js.4.24.0/Choice.js";
import { defaultOf, structuralHash, equals, compare } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, collect, map, delay, toList, contains } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { totalSeconds, seconds, minutes } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { matches, create as create_1, match } from "../fable_modules/fable-library-js.4.24.0/RegExp.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { isEmpty as isEmpty_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";

export class InvariantCulture {
    constructor() {
    }
}

export function InvariantCulture_$reflection() {
    return class_type("Shopfoo.Common.Common.InvariantCulture", undefined, InvariantCulture);
}

export function InvariantCulture_get_ListSeparator() {
    return ",";
}

export function InvariantCulture_Format_1505(value) {
    let copyOfStruct = value;
    return toString(copyOfStruct);
}

export function InvariantCulture_ParseDateOnly_Z721C83C5(s) {
    return fromDateTime(parse(s));
}

export function InvariantCulture_ParseDateTime_Z721C83C5(s) {
    return parse(s);
}

export function InvariantCulture_ParseDecimal_Z721C83C5(s) {
    return parse_1(s);
}

export function InvariantCulture_TryParseDateOnly_Z721C83C5(s) {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return [true, fromDateTime(matchValue[1])];
    }
    else {
        return [false, minValue_1()];
    }
}

export function InvariantCulture_TryParseDateTime_Z721C83C5(s) {
    let outArg = minValue();
    return [tryParse(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
}

export function InvariantCulture_TryParseDecimal_Z721C83C5(s) {
    let outArg = new Decimal("0");
    return [tryParse_1(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
}

/**
 * Wrap the <paramref name="value"/> in an <see cref="Option"/> if it's a <paramref name="success"/>.
 */
export function Option_ofPair(success, value) {
    if (success) {
        return some(value);
    }
    else {
        return undefined;
    }
}

/**
 * Create a <c>unit option</c> from the given <paramref name="success"/> flag.
 */
export function Option_ofBool(success) {
    return Option_ofPair(success, undefined);
}

/**
 * Wrap the given string <paramref name="s"/> in an <see cref="Option"/>
 */
export function Option_ofNonNullOrWhitespace(s) {
    const matchValue = isNullOrWhiteSpace(s);
    if (matchValue) {
        return undefined;
    }
    else {
        return s;
    }
}

export function Result_bindError(fError, xR) {
    if (xR.tag === 1) {
        return fError(xR.fields[0]);
    }
    else {
        return new FSharpResult$2(0, [xR.fields[0]]);
    }
}

export function Result_force(xR) {
    if (xR.tag === 1) {
        throw new Error("Result was expected to be Ok, but was Error.");
    }
    else {
        return xR.fields[0];
    }
}

export function Result_mapOption(f, opt) {
    if (opt != null) {
        const matchValue = f(value_2(opt));
        if (matchValue.tag === 1) {
            return new FSharpResult$2(1, [matchValue.fields[0]]);
        }
        else {
            return new FSharpResult$2(0, [some(matchValue.fields[0])]);
        }
    }
    else {
        return new FSharpResult$2(0, [undefined]);
    }
}

export function Result_tryGetError(xR) {
    if (xR.tag === 1) {
        return some(xR.fields[0]);
    }
    else {
        return undefined;
    }
}

export class SetExtensions {
    constructor() {
    }
}

export function SetExtensions_$reflection() {
    return class_type("Shopfoo.Common.Common.SetExtensions", undefined, SetExtensions);
}

export function SetExtensions_Toggle_Z596FB3C0(set$, item, isSelected) {
    if (isSelected) {
        return FSharpSet__Add(set$, item);
    }
    else {
        return FSharpSet__Remove(set$, item);
    }
}

export function SetExtensions_Toggle_11A9516A(set$, item) {
    return SetExtensions_Toggle_Z596FB3C0(set$, item, FSharpSet__Contains(set$, item));
}

export function Set_$007CEmpty$007CNotEmpty$007C(set$) {
    if (isEmpty(set$)) {
        return new FSharpChoice$2(0, [undefined]);
    }
    else {
        return new FSharpChoice$2(1, [undefined]);
    }
}

export function ActivePatterns_$007CBetween$007C_$007C(min, max, value) {
    return Option_ofBool((compare(value, min) >= 0) && (compare(value, max) <= 0));
}

export function ActivePatterns_$007CIn$007C_$007C(values, value) {
    return Option_ofBool(contains(value, values, {
        Equals: equals,
        GetHashCode: structuralHash,
    }));
}

export function ActivePatterns_$007CIs$007C_$007C(otherValue, value) {
    return Option_ofBool(equals(value, otherValue));
}

export function ActivePatterns_$007CNull$007CNotNull$007C(value) {
    if (value == null) {
        return new FSharpChoice$2(0, [undefined]);
    }
    else {
        return new FSharpChoice$2(1, [undefined]);
    }
}

export function Nullable_$007CValue$007CNull$007C(nullable) {
    const matchValue = ofNullable(nullable);
    if (matchValue == null) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [value_2(matchValue)]);
    }
}

export function System_DateOnly__DateOnly_ToDateTime(this$) {
    return toDateTime(this$, 0);
}

export function System_DateOnly__DateOnly_get_Today_Static() {
    return fromDateTime(today());
}

export const DateOnly_Default = create(1900, 1, 1);

export function DateOnly_toInvariantString(d) {
    return InvariantCulture_Format_1505(d);
}

export function DateOnly_tryParse(s) {
    const tupledArg = InvariantCulture_TryParseDateOnly_Z721C83C5(s);
    return Option_ofPair(tupledArg[0], tupledArg[1]);
}

export function TimeOnly_$007CHoursOnly$007CHoursMinutes$007CHoursMinutesSeconds$007C(timeOnly) {
    const matchValue = minutes(timeOnly) | 0;
    const matchValue_1 = seconds(timeOnly) | 0;
    let matchResult;
    if (matchValue === 0) {
        if (matchValue_1 === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 2;
        }
    }
    else if (matchValue_1 === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return new FSharpChoice$3(0, [undefined]);
        case 1:
            return new FSharpChoice$3(1, [undefined]);
        default:
            return new FSharpChoice$3(2, [undefined]);
    }
}

export function TimeSpan_$007CTotalSeconds$007C(timeSpan) {
    return totalSeconds(timeSpan);
}

export function Regex_$007CMatch$007C_$007C(pattern, value) {
    const m = match(create_1(pattern), value);
    if (!(m != null) ? true : (m.length < 1)) {
        return undefined;
    }
    else {
        return toList(delay(() => map((i) => (m[i] || ""), rangeDouble(1, 1, m.length - 1))));
    }
}

export function Regex_$007CMatches$007C_$007C(pattern, value) {
    return filter((arg) => !isEmpty_1(arg), toList(delay(() => collect((m) => (((m != null) && (m.length > 0)) ? singleton(toList(delay(() => map((i) => (m[i] || ""), rangeDouble(1, 1, m.length - 1))))) : empty()), matches(create_1(pattern), value)))));
}

export function PrettyPrint_prettyPrintString(s) {
    if (s === defaultOf()) {
        return "null";
    }
    else {
        return `‟${s}”`;
    }
}

export function PrettyPrint_prettyPrintObject(o) {
    let matchResult;
    if (equals(o, defaultOf())) {
        matchResult = 0;
    }
    else if (typeof o === "boolean") {
        matchResult = 1;
    }
    else if (typeof o === "number") {
        matchResult = 1;
    }
    else if (typeof o === "number") {
        matchResult = 1;
    }
    else if (o instanceof Decimal) {
        matchResult = 1;
    }
    else if (typeof o === "string") {
        matchResult = 2;
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return "null";
        case 1:
            return InvariantCulture_Format_1505(o);
        case 2:
            return PrettyPrint_prettyPrintString(o);
        default:
            return toText(interpolate("%A%P()", [o]));
    }
}

export function PrettyPrint_prettyPrintOption(option) {
    if (option != null) {
        return PrettyPrint_prettyPrintObject(value_2(option));
    }
    else {
        return "None";
    }
}

export function PrettyPrint_prettyConcat(texts) {
    return join(InvariantCulture_get_ListSeparator(), texts);
}

